import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { inRoomDiningAddOnSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';

const ItemViewAddOns = (props) => {
  const { selectedItem } = props;
  const [loading, setLoading] = useState(true);
  const originalAddons = useSelector(inRoomDiningAddOnSelector);
  const [itemAddons, setItemAddons] = useState(null);

  useEffect(() => {
    let currAddon = null;
    if (selectedItem.addons.type === 'INACTIVE') {
      currAddon = null;
      setItemAddons(currAddon);
    } else {
      currAddon = { ...selectedItem?.addons };
      if (currAddon?.type === 'GROUPED') {
        const groupedAddon = currAddon.groupedAddon.map((groupedAddon) => {
          const addonItem = groupedAddon.addons.map((addonItem) => {
            const getAddon = originalAddons.find((addonsDetails) => addonsDetails.id === addonItem);
            return getAddon && getAddon?.name ? getAddon?.name : null;
          });
          return { ...groupedAddon, addons: addonItem };
        });
        currAddon.groupedAddon = groupedAddon;
      } else {
        const unGroupedAddons = currAddon.addons.map((addonItem) => {
          const getAddon = originalAddons.find((addonsDetails) => addonsDetails.id === addonItem);
          return getAddon?.name;
        });
        currAddon.unGroupedAddons = unGroupedAddons;
      }
      setItemAddons(currAddon);
    }
    setLoading(false);
  }, [selectedItem]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : itemAddons && itemAddons?.type !== 'INACTIVE' ? (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-12'>
              <div className='details-label mb-2'>Add-Ons</div>
              <p className='text-black'>
                {itemAddons?.type.charAt(0).toUpperCase() + itemAddons?.type.slice(1).toLowerCase()}
              </p>
              {itemAddons?.type === 'GROUPED' ? (
                <>
                  <div className='details-label mb-2 mt-2'>Add-on Groups</div>
                  {itemAddons.groupedAddon.map((addonItem, index) => (
                    <p className='text-black' key={index}>
                      {addonItem?.title}
                      {`(${addonItem?.limit})`}:
                      {addonItem?.addons?.map((adddon) => adddon)?.join(', ')}
                    </p>
                  ))}
                </>
              ) : (
                <>
                  <div className='details-label mb-2 mt-2'>Add-on Names</div>
                  <p>{itemAddons?.unGroupedAddons?.map((addonItem) => addonItem)?.join(', ')}</p>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-6'>
              <div className='details-label'>No AddOns Available</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ItemViewAddOns;
